import ExpandableCard from './ExpandableCard'

export default ExpandableCard
